var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPersonIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 18,
  viewBox: "0 0 16 18",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#7D7D7D",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 0a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 1.2a2.8 2.8 0 1 0 0 5.6 2.8 2.8 0 0 0 0-5.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.89 7.4H7.308C3.513 7.4.4 10.147.4 13.595v3.834h15.2v-3.97c0-3.455-2.922-6.059-6.71-6.059zm0 1.2.24.004c3.033.104 5.27 2.167 5.27 4.854v2.771H1.6v-2.634c0-2.75 2.545-4.995 5.709-4.995h1.58z"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPersonIcon);
export default ForwardRef;